import React from 'react'

const ImageQuoteBlack = () => {
    return(
        <div className="quoteImage">
            <h1>resume and projects</h1>
            <p>Click on an image below to see links and descriptions of my current and past works.</p>
        </div>
    )
}

export default ImageQuoteBlack